<template>
 <AppDialog :is-open="isOpen"
            :ok-title="$t('common.delete')"
            :ok-loading="deleteQuestionPending"
            :ok-disabled="deleteQuestionPending"
            :cancel-disabled="deleteQuestionPending"
            @ok="prepareDeleteQuestion"
            @cancel="closeDialog"
 >
   <template #title>
     {{ $t('project.question-answer.QuestionAnswerQuestionDeleteDialog.title') }}
   </template>
   <template #body>
     <div>
       {{ $t('project.question-answer.QuestionAnswerQuestionDeleteDialog.text') }}
     </div>
   </template>
 </AppDialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { toast } from '@/common/utils/toast'
import { QuestionAnswerActionTypes } from '@/store/modules/question-answer/action_types'

export default {
  name: 'QuestionAnswerQuestionDeleteDialog',
  components: { AppDialog },
  props: {
    questionId: {
      required: true,
      validator: (value) => {
        return value === null || typeof value === 'number'
      },
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('room', ['roomMnemo']),
    ...mapState('questionAnswer', ['deleteQuestionPending', 'questions']),
  },
  methods: {
    ...mapActions('questionAnswer', [
      QuestionAnswerActionTypes.DELETE_QUESTION,
      QuestionAnswerActionTypes.GET_QUESTIONS,
    ]),
    async prepareDeleteQuestion () {
      try {
        await this.DELETE_QUESTION({
          mnemo: this.roomMnemo,
          questionId: this.questionId,
        })
        toast.success(this.$t('project.question-answer.QuestionAnswerQuestionDeleteDialog.deleteQuestionSuccess'))
        this.closeDialog()
        await this.GET_QUESTIONS(this.roomMnemo)
      } catch (error) {
        toast.error(this.$t('project.question-answer.QuestionAnswerQuestionDeleteDialog.deleteQuestionError'))
      }
    },
    closeDialog () {
      this.$emit('onClose')
    },
  },
}
</script>
